<div *ngIf="formObject">
  <mat-form-field appearance="standard" class="w-100">
    <mat-label [ngStyle]="isFirst ? {'visibility': 'visible'} : {'visibility' : 'hidden'}">
      {{label}}
      <sup *ngIf="isInfo">
        <mat-icon class="fas fa-info" style="font-size: 0.5rem"></mat-icon>
      </sup>
    </mat-label>
    <input matInput #inputElement
           type="text"
           requireObject [initialValue]="initialString"
           [required]="required"
           [disabled]="isDisabled"
           [placeholder]="label"
           [name]="elementName"
           [matAutocomplete]="auto"
           [(ngModel)]="ngModelObject"
           (focusin)="getOptions(ngModelObject)"
           (focusout)="checkInputValidity()"
           (ngModelChange)="emitChangeToGetOptions($event, inputElement)">
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setSelectedOption($event)">
      <mat-option *ngFor="let option of options" [value]="option">
        {{option}}
      </mat-option>
    </mat-autocomplete>
    <button mat-icon-button matSuffix
            [matTooltip]="'forms.osp.tabs.profession.add_profession.tooltip' | translate"
            (click)="addProfession()" [ngStyle]="isAddProfession ? {visibility: 'visible'} : {visibility: 'hidden'}">
      <mat-icon>person_add</mat-icon>
    </button>
    <mat-error>
      {{'forms.common.error_message.pick_from_list' | translate}}
    </mat-error>
  </mat-form-field>
</div>
